<div class="commandes-create-container">
  <h2>Créer une commande</h2>
    @if (success) {
      <div class="success">{{ success }}</div>
    }
    @if (error) {
      <div class="error">{{ error }}</div>
    }
      <form (ngSubmit)="save()" #form="ngForm">

      <label for="numero_commande">Numéro de commande faite par le client à Veolia</label>
      <input  [(ngModel)]="commande.numero_commande" name="numero_commande" id="numero_commande" required>


      <label for="client_id">Client *</label>
    
      <select id="client_id" name="client_id" [(ngModel)]="commande.client_id" required>
        <option value="">-- sélectionner --</option>
        @for (client of clients; track client.id) {
          <option [value]="client.id">{{ client.identifiant }}</option>
        }
      </select>

      <label for="nombre_capteurs">Nombre de capteurs</label>
      <input
        [(ngModel)]="commande.nombre_capteurs"
        name="nombre_capteurs"
        id="nombre_capteurs"
        type="number"
        min="0"
      >

    <button  color="primary" type="submit" [disabled]="saving || form.invalid">Créer</button>
    <button  type="button" routerLink="/commandes">Annuler</button>
  </form>
</div>
